export const jsUcfirst = string =>
	string.charAt(0).toUpperCase() + string.slice(1);

export const truncate = (
	str,
	limit = 20,
	breakChar = " ",
	rightPad = "..."
) => {
	if (str.length <= limit) {
		return str;
	}
	const substr = str.substr(0, limit);
	const breakPoint = substr.lastIndexOf(breakChar);
	if (breakPoint >= 0) {
		if (breakPoint < str.length - 1) {
			return str.substr(0, breakPoint) + rightPad;
		}
	}
};

export const calculaPorcentaje = (puntos, total) =>
	Math.floor(puntos / total * 100);

// He cambiado !== -1
export const quitaAcentos = str => {
	let accents =
		"ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
	let accentsOut =
		"AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
	str = str.split("");
	str.forEach((letter, index) => {
		let i = accents.indexOf(letter);
		if (i !== -1) {
			str[index] = accentsOut[i];
		}
	});
	return str.join("");
};

export const getMainColor = ide => {
	let identificador = ide.split("_")[0];
	let rojo = "#E73729";
	let azul = "#298EF1";
	let amarillo = "#F8AF2A";
	let verde = "#379C5C";

	if (identificador === "cor") {
		return rojo;
	}
	if (identificador === "chi") {
		return azul;
	}
	if (identificador === "com") {
		return amarillo;
	}
	if (identificador === "cua") {
		return verde;
	}
};

export const fechas = {
	1: {
		dia: "9",
		cod: "clas_",
		txt: "9 de enero",
		sesion: "1",
		fecha: "01/09/2018",
		fase: "Primera sesión clasificatoria"
	},
	2: {
		dia: "10",
		cod: "clas_",
		txt: "10 de enero",
		sesion: "2",
		fecha: "01/10/2018",
		fase: "Segunda sesión clasificatoria"
	},
	3: {
		dia: "11",
		cod: "clas_",
		txt: "11 de enero",
		sesion: "3",
		fecha: "01/11/2018",
		fase: "Tercera sesión clasificatoria"
	},
	4: {
		dia: "12",
		cod: "clas_",
		txt: "12 de enero",
		sesion: "4",
		fecha: "01/12/2018",
		fase: "Cuarta sesión clasificatoria"
	},
	5: {
		dia: "13",
		cod: "clas_",
		txt: "13 de enero",
		sesion: "5",
		fecha: "01/13/2018",
		fase: "Quinta sesión clasificatoria"
	},
	6: {
		dia: "14",
		cod: "clas_",
		txt: "14 de enero",
		sesion: "6",
		fecha: "01/14/2018",
		fase: "Sexta sesión clasificatoria"
	},
	7: {
		dia: "15",
		cod: "clas_",
		txt: "15 de enero",
		sesion: "7",
		fecha: "01/15/2018",
		fase: "Séptima sesión clasificatoria"
	},
	8: {
		dia: "16",
		cod: "clas_",
		txt: "16 de enero",
		sesion: "8",
		fecha: "01/16/2018",
		fase: "Octava sesión clasificatoria"
	},
	9: {
		dia: "17",
		cod: "clas_",
		txt: "17 de enero",
		sesion: "9",
		fecha: "01/17/2018",
		fase: "Novena sesión clasificatoria"
	},
	10: {
		dia: "18",
		cod: "clas_",
		txt: "18 de enero",
		sesion: "10",
		fecha: "01/18/2018",
		fase: "Décima sesión clasificatoria"
	},
	11: {
		dia: "19",
		cod: "clas_",
		txt: "19 de enero",
		sesion: "11",
		fecha: "01/19/2018",
		fase: "Undécima sesión clasificatoria"
	},
	12: {
		dia: "20",
		cod: "clas_",
		txt: "20 de enero",
		sesion: "12",
		fecha: "01/20/2018",
		fase: "Duodécima sesión clasificatoria"
	},
	13: {
		dia: "21",
		cod: "clas_",
		txt: "21 de enero",
		sesion: "13",
		fecha: "01/21/2018",
		fase: "13ª sesión clasificatoria"
	},
	14: {
		dia: "22",
		cod: "clas_",
		txt: "22 de enero",
		sesion: "14",
		fecha: "01/22/2018",
		fase: "14ª sesión clasificatoria"
	},
	15: {
		dia: "23",
		cod: "clas_",
		txt: "23 de enero",
		sesion: "15",
		fecha: "01/23/2018",
		fase: "15ª sesión clasificatoria"
	},
	16: {
		dia: "24",
		cod: "clas_",
		txt: "24 de enero",
		sesion: "16",
		fecha: "01/24/2018",
		fase: "16ª sesión clasificatoria"
	},
	17: {
		dia: "25",
		cod: "clas_",
		txt: "25 de enero",
		sesion: "17",
		fecha: "01/25/2018",
		fase: "17ª sesión clasificatoria"
	},
	18: {
		dia: "26",
		cod: "clas_",
		txt: "26 de enero",
		sesion: "18",
		fecha: "01/26/2018",
		fase: "Penúltima sesión clasificatoria"
	},
	19: {
		dia: "27",
		cod: "clas_",
		txt: "27 de enero",
		sesion: "19",
		fecha: "01/27/2018",
		fase: "Última sesión clasificatoria"
	},
	// '01/28/2018'
	20: {
		dia: "28",
		cod: "clas_",
		txt: "28 de enero",
		sesion: "0",
		fecha: "01/28/2018",
		fase: "Jornada de descanso"
	},
	21: {
		dia: "29",
		cod: "cuar_",
		txt: "29 de enero",
		sesion: "20",
		fecha: "01/29/2018",
		fase: "Primera sesión de cuartos"
	},
	22: {
		dia: "30",
		cod: "cuar_",
		txt: "30 de enero",
		sesion: "21",
		fecha: "01/30/2018",
		fase: "Segunda sesión de cuartos"
	},
	23: {
		dia: "31",
		cod: "cuar_",
		txt: "31 de enero",
		sesion: "22",
		fecha: "01/31/2018",
		fase: "Tercera sesión de cuartos"
	},
	24: {
		dia: "1",
		cod: "cuar_",
		txt: "1 de febrero",
		sesion: "23",
		fecha: "02/01/2018",
		fase: "Cuarta sesión de cuartos"
	},
	25: {
		dia: "2",
		cod: "cuar_",
		txt: "2 de febrero",
		sesion: "24",
		fecha: "02/02/2018",
		fase: "Penúltima sesión de cuartos"
	},
	26: {
		dia: "3",
		cod: "cuar_",
		txt: "3 de febrero",
		sesion: "25",
		fecha: "02/03/2018",
		fase: "Última sesión de cuartos"
	},
	27: {
		dia: "4",
		cod: "cuar_",
		txt: "4 de febrero",
		sesion: "0",
		fecha: "02/04/2018",
		fase: "Jornada de descanso"
	},
	28: {
		dia: "5",
		cod: "semis_",
		txt: "5 de febrero",
		sesion: "26",
		fecha: "02/05/2018",
		fase: "Primera semifinal"
	},
	29: {
		dia: "6",
		cod: "semis_",
		txt: "6 de febrero",
		sesion: "27",
		fecha: "02/06/2018",
		fase: "Segunda semifinal"
	},
	30: {
		dia: "7",
		cod: "semis_",
		txt: "7 de febrero",
		sesion: "28",
		fecha: "02/07/2018",
		fase: "Última semifinal"
	},
	31: {
		dia: "8",
		cod: "semis_",
		txt: "8 de febrero",
		sesion: "0",
		fecha: "02/08/2018",
		fase: "Jornada de descanso"
	},
	32: {
		dia: "9",
		cod: "semis_",
		txt: "9 de febrero",
		sesion: "29",
		fecha: "02/09/2018",
		fase: "Final"
	}
};

// ACCESO
// console.log(fechas.dias.cua5.fase);

// FIRMA

console.log(
	`%c

██████    █████
██   ██  ██
██   ██  ██
██████    █████` +
	`%c

███████████████` +
	`
%c
Diario de Cádiz
J.A. ${new Date().getFullYear()}

`,
	"font-family: monospace; font-size: 12px; line-height: 12px",
	"font-family: monospace; font-size: 12px; color: #CF2D26; line-height: 12px",
	"display: block"
);



// WEBPACK FOOTER //
// ./src/utils/helpers.js